/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type BillingEmail = {
  /**
   * The configured billing notification email. Omitted when organization administrators receive billing notifications.
   */
  email?: string | null | undefined;
};

/** @internal */
export const BillingEmail$inboundSchema: z.ZodMiniType<BillingEmail, unknown> =
  z.object({
    email: z.optional(z.nullable(z.string())),
  });
/** @internal */
export type BillingEmail$Outbound = {
  email?: string | null | undefined;
};

/** @internal */
export const BillingEmail$outboundSchema: z.ZodMiniType<
  BillingEmail$Outbound,
  BillingEmail
> = z.object({
  email: z.optional(z.nullable(z.string())),
});

export function billingEmailToJSON(billingEmail: BillingEmail): string {
  return JSON.stringify(BillingEmail$outboundSchema.parse(billingEmail));
}
export function billingEmailFromJSON(
  jsonString: string,
): SafeParseResult<BillingEmail, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BillingEmail$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BillingEmail' from JSON`,
  );
}
